import { render, staticRenderFns } from "./BoxEntranceTable.vue?vue&type=template&id=72c387e8&scoped=true&"
import script from "./BoxEntranceTable.vue?vue&type=script&lang=js&"
export * from "./BoxEntranceTable.vue?vue&type=script&lang=js&"
import style0 from "./BoxEntranceTable.vue?vue&type=style&index=0&id=72c387e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c387e8",
  null
  
)

/* custom blocks */
import block0 from "./BoxEntranceTable.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./BoxEntranceTable.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip,QBtnToggle,QTable,QTr,QTh,QTd,QBtn,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QTooltip,QBtnToggle,QTable,QTr,QTh,QTd,QBtn,QInnerLoading,QSpinnerTail})
